import { useQuery } from '@tanstack/react-query';
import apiClient from '../../../api/client';
import type { PermissionResponse, Paginated } from '../../../api/types';
import { permissionsKeys } from './keys';

interface PermissionsListParams extends Record<string, unknown> {
  limit?: number;
  offset?: number;
  search?: string;
}

export function usePermissionsList(params: PermissionsListParams = {}) {
  return useQuery<Paginated<PermissionResponse>>({
    queryKey: permissionsKeys.list(params),
    queryFn: async () => {
      const { data } = await apiClient.get<Paginated<PermissionResponse>>('/admin/permissions', {
        params,
      });
      return data;
    },
    staleTime: 30_000,
  });
}
